import { Edit } from "react-admin";
import { useAdmin } from "../../hooks/admin";
import { SupplierForm } from "./_form";
import { buckets } from "@/core/buckets";
import { uploadFile } from "@/utils/file-upload";
import { nanoid } from "nanoid";

export const SupplierEdit = () => {
  const { hasPermission } = useAdmin();

  if (!hasPermission("supplier.update")) return null;

  const transform = async (data: any) => {
    const rest = { ...data };
    if (rest.logo?.rawFile) {
      rest.logo = await uploadFile(
        buckets.banners,
        "SupplierLogos",
        nanoid(),
        rest.logo.rawFile
      );
    }
    return rest;
  };

  return (
    <Edit mutationMode="pessimistic" redirect="show" transform={transform}>
      <SupplierForm isEdit />
    </Edit>
  );
};
